import {ApiFeatureFlagRepository} from '@infra/domain/model/FeatureFlag/ApiFeatureFlagRepository';

import {GetFeatureFlags} from './GetFeatureFlags';

export const FeatureFlagApplication = {
  getFeatureFlags: GetFeatureFlags(ApiFeatureFlagRepository),
};
